export default __webpack_public_path__ + "static/media/animal-health.0a70637c.jpg";